// extracted by mini-css-extract-plugin
export default {"dividerContainer":"Divider_dividerContainer__IU8ey"};